import { Release } from "shared-ts-release";
import { Typography } from "@mui/material";
import development_and_prediction_of_need_for_sweep_chart from "./development_and_prediction_of_need_for_sweep_chart.png";
import sooting_degree from "./sooting_degree.png";
import new_need_for_sweep_tab from "./new_need_for_sweep_tab.png";
import need_for_sweep_in_percent from "./need_for_sweep_in_percent.png";

export const release_2025_1_0: Release = {
  version: "2025.1.0",
  date: "2025-03-17",
  entries: [
    {
      type: "Feature",
      heading: "Røykløpets feiebehov i %",
      description: (
        <>
          <Typography>
            I stedet for å snakke om et feiebehov ved en sot-indeks på 4000, så
            regner vi nå om sot-indeksen til{" "}
            <b>
              <i>Feiebehov i %</i>
            </b>{" "}
            ved å dele røykløpets sot-indeks på sot-indeks-terskelen for
            feibehov.
          </Typography>
          <img
            src={need_for_sweep_in_percent}
            alt={"need_for_sweep_in_percent"}
            width={"100%"}
            style={{ marginTop: "1em", marginBottom: "0.5em" }}
          />
        </>
      ),
    },
    {
      type: "Feature",
      heading: "Sotingsgrad",
      description: (
        <>
          <Typography>
            Vi har innført et nytt begrep: <b>sotingsgrad</b>, som i deler av
            applikasjonen vil erstatte sot-indeks der <b>feiebehov i %</b> ikke
            passer like godt.
          </Typography>
          <img
            src={sooting_degree}
            alt={sooting_degree}
            width={"100%"}
            style={{ marginTop: "1em", marginBottom: "0.5em" }}
          />
        </>
      ),
    },
    {
      type: "Feature",
      heading: "Røykløpets utvikling og forutseelse av feiebehov",
      description: (
        <>
          <Typography>
            Røykløpets oversikts-fane har fått et nytt diagram som viser
            utviklingen og forutseelse av feiebehovet til røykløpet:{" "}
          </Typography>
          <img
            src={development_and_prediction_of_need_for_sweep_chart}
            alt={"development_and_prediction_of_need_for_sweep_chart"}
            width={"100%"}
            style={{ marginTop: "1em", marginBottom: "0.5em" }}
          />
          <Typography>
            Diagrammet viser utviklingen og forutseelsen av røykløpets
            sotingsgrad og fyringstimer.
          </Typography>
        </>
      ),
    },
    {
      type: "Feature",
      heading: "Egen fane for røykløpets feiebehov",
      description: (
        <>
          <Typography>
            Røykløps-dialogen har fått en egen fane for feiebehov, som viser mer
            detaljer feiebehovet til røykløpet.
          </Typography>
          <img
            src={new_need_for_sweep_tab}
            alt={"new_need_for_sweep_tab"}
            width={"100%"}
            style={{ marginTop: "1em" }}
          />
        </>
      ),
    },
    {
      type: "Improvement",
      heading: "Mulighet til å angi mengde avfall ved feiing i liter",
      description: (
        <>
          <Typography>
            Det er nå mulig å angi mengde avfall ved feiing i liter.
          </Typography>
          <Typography sx={{ pt: 1 }}>
            Hvis du allerede har registrert feiinger med avfall som du egentlig
            målte i liter, så har du nå muligheten til å endre enheten fra 'kg'
            til 'l'.
          </Typography>
        </>
      ),
    },
    {
      type: "Bugfix",
      heading:
        "Røykløp som har et forfalt feiebehov vises med grønn farge i kartet",
      description: (
        <>
          <Typography>
            Kartnålen vises nå med rød farge for røykløp med et forfalt
            feiebehov.
          </Typography>
        </>
      ),
    },
  ],
};
